//スマホのみで適用

 if (window.matchMedia && window.matchMedia('(max-device-width:1000px)').matches) {
    var sp = true;
  } else {
    var sp = false;
  }

if(sp == true){

  //サイト訪問時にtest=Aかtest=Bかみる

  const st = localStorage.getItem("test");
  if (st == null) {
    var check = false;
  } else {
    var check = true;
  }


  if (check == true) {
    var pattern = st;
  } else {
    let abtestran = Math.floor(Math.random() * 2);
    if (abtestran > 0) {
      var pattern = "A";
    } else {
      var pattern = "B";
    }
    localStorage.setItem("test", pattern);
  }


  //URL判定
  const listurls = ["https://www.strapya.com/collections/iphone-13pro-case",];
  const goodsurls = [
	  "https://www.strapya.com/products/41-925",
	  "https://www.strapya.com/products/41-9359",
	  "https://www.strapya.com/products/669-9282",
	  "https://www.strapya.com/products/41-9",
	  "https://www.strapya.com/products/41-9318",
	  "https://www.strapya.com/products/276-9010",
	  "https://www.strapya.com/products/276-8907",
	  "https://www.strapya.com/products/276-935",
	  "https://www.strapya.com/products/669-9294",
	  "https://www.strapya.com/products/276-9379",
	  "https://www.strapya.com/products/276-923",
	  "https://www.strapya.com/products/276-9255",
	  "https://www.strapya.com/products/276-8988",
	  "https://www.strapya.com/products/276-8956",
	  "https://www.strapya.com/products/669-7500",
	  "https://www.strapya.com/products/276-9065",
	  "https://www.strapya.com/products/276-8955",
	  "https://www.strapya.com/products/276-9358",
	  "https://www.strapya.com/products/276-8989",
	  "https://www.strapya.com/products/276-9007",
	  "https://www.strapya.com/products/276-9010-9196",
	  "https://www.strapya.com/products/276-9137",
	  "https://www.strapya.com/products/276-9008",
      "https://www.strapya.com/products/360-900"
  ];
  const url = location.href;
   if(url.indexOf("?") != -1){
    var urlafters = url.split('?')[0];
   }else{
  	var urlafters = url
  }

  if(url.indexOf("#") != -1){
   	var urlafter = urlafters.split('#')[0];
  }else{
  	var urlafter = urlafters;
  }


  //商品ページ
  if(url.indexOf("/products/") != -1){

    //リダイレクト処理
    if(url.indexOf('test=') == -1){
      setTimeout(function(){
        if(url.indexOf("?") != -1){
            //location.href=url+"&test="+pattern;
        }else{
            //location.href=url+"?test="+pattern;
        }
       },500);
    }

    if(pattern =="A"){ }else{}







    // var head = document.getElementsByTagName('head')[0];
    // var link = document.createElement('link');
    // link.setAttribute('rel','stylesheet');
    // link.setAttribute('type','text/css');
    // link.setAttribute('href','https://www.strapya.com/cdn/shop/t/21/assets/abtest_221003.css?v=20448450581247060871726645175122');
    // head.appendChild(link);

    document.addEventListener('DOMContentLoaded',function(){
      breakpoint();
    });

    window.addEventListener('load',function(){
      addOnAccordion();
      blockDisabled();
    });

   document.addEventListener('DOMContentLoaded',function(){

  var main = document.getElementById('main');
  var productInfo = Array.prototype.slice.call(main.getElementsByClassName('product-info'))[0];
  var tgt =  Array.prototype.slice.call(productInfo.getElementsByClassName('product-form__payment-container'))[0];



     	var banner = '<br><ul id="bannerBox">'+
		  '<li>'+
		  '<a href="https://www.strapya.com/pages/howto-coupon"><img width="100%" alt="2点10%OFF" src="https://cdn.shopify.com/s/files/1/0503/0812/0749/files/2312cs_10off_137h.jpg?v=1703917686"></a>'+
		  '</li>'+
		  '</ul>';
		tgt.insertAdjacentHTML('beforeend',banner);

		    });





  function blockDisabled(){

    var target = document.querySelectorAll('.block-swatch--disabled');
    if(target.length > 0){

      target.forEach(function(value){
        value.disabled = true;
      });

    }

    var select = document.querySelectorAll("select.product-form__single-selector");
    select.forEach(function(value){
      value.addEventListener('change',function(){
        select.forEach(function(value2){
          var opt = value2.querySelectorAll("option");
          opt.forEach(function(each){
            each.disabled = false;
          });
          setTimeout(function(){
          var target = value2.querySelectorAll('.block-swatch--disabled');
            target.forEach(function(each2){
              each2.disabled = true;
            });
            },100);
        });
      });
    });



  }


    function addOnAccordion(){

      //準備
    	var target = document.getElementById('spiceaddonsappid');
      var trect = target.getBoundingClientRect();
      var ttop = trect.top;
        if(target != null){
          target.insertAdjacentHTML('afterend','<div id="accBtn" class="closeAcc">もっと見る</div>');
          var ps = target.getElementsByClassName('sg-pro-access-product');
          var p = Array.prototype.slice.call(ps);
          if(p.length > 0){
            p.forEach(function(value,i){
              if(i == 1){
                var vrect = value.getBoundingClientRect();
                 var vbottom = vrect.bottom;
                var height = parseFloat(vbottom - ttop + 20);
                target.style.height = height + "px";
              }
            });
          }else{
              //  target.style.display = "none";
            var trigger = document.getElementById('accBtn');
            if(trigger != null){
               trigger.style.display = "none";
            }
          }
        }

      //開く閉じる
      var trigger = document.getElementById('accBtn');
      if(target != null && trigger != null){

        trigger.addEventListener('click',function(){
        	var classlist = Array.prototype.slice.call(trigger.classList);
          if(classlist.indexOf('closeAcc') != -1){
          	trigger.classList.remove('closeAcc');
            trigger.classList.add('openAcc');
            trigger.textContent = "閉じる";
            var nowheight = target.style.height;
            target.setAttribute('height',nowheight);
            target.style.height = "";
          }else{
          	trigger.classList.remove('openAcc');
            trigger.classList.add('closeAcc');
            trigger.textContent = "もっと見る";
            var nowheight = target.getAttribute('height');
            target.removeAttribute('height');
            target.setAttribute('style','height:'+nowheight);
          }
        });

      }
    }


    function breakpoint(){
    	var p = Array.prototype.slice.call(document.getElementsByClassName('product-block-list__item--description'));
      if(p != undefined && p.length > 0){
        p.forEach(function(value){
        	var t = Array.prototype.slice.call(value.getElementsByClassName('text--pull'));
          if(t != undefined && t.length > 0){
            t.forEach(function(each){
                var i = Array.prototype.slice.call(each.getElementsByTagName('img'));
                var a = Array.prototype.slice.call(each.getElementsByTagName('a'));
                var s = Array.prototype.slice.call(each.getElementsByTagName('span'));
                var d = Array.prototype.slice.call(each.getElementsByTagName('div'));
                var h = Array.prototype.slice.call(each.getElementsByTagName('hr'));
              	var all = i.concat(a,s,d,h);
              all.forEach(function(single){
              	var pre = single.previousElementSibling;
                if(pre != null && pre.tagName == "BR"){
                	pre.style.display = "none";
                }
              });

            	var html = value.outerHTML;
              	value.outerHTML = "";

              	var review = document.getElementById('judgeme_product_reviews');
              review.insertAdjacentHTML('afterend',html);

            });
          }
        });
      }
    }




  }//商品ページ



}//sp=true



window.addEventListener('load',function(){
	linkOption();
});


//選択肢の連動
function linkOption(){

	var newopt = document.querySelectorAll('.cart_list');
	var oldopt = document.querySelectorAll('.block-swatch-list.abtest');
	if(newopt.length > 0 && oldopt.length > 0){
	oldopt.forEach(function(value){
		var label = value.querySelectorAll('label');
		label.forEach(function(each){
			each.addEventListener('click',function(){
				var ttl = each.getAttribute('title');
				newopt.forEach(function(v2){
					var swatch = v2.querySelectorAll('.block-swatch');
					swatch.forEach(function(e2){
						var v = e2.getAttribute('value');
						if(ttl == v){
							var p = e2.parentElement;
							p.value = v;
							e2.setAttribute('selected','selected');
						}else{
							e2.removeAttribute('selected');
						}
					});
				});
			});

		});
	});
	}
}
